module.exports = __webpack_public_path__ + "static/media/a1.0ba21da.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengqingsheng/a1.mp3
// module id = lrUk
// module chunks = 0